import sumBy from 'lodash-es/sumBy'

import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../../../constants/rentalPortal'
import { getMatchCriterionLabelKey } from '../../../../RentalPortalMatch'

import { MATCH_BREAKDOWN_DECIMALS } from './ApplicantFitCheckBlockBreakdown.constants'

export function getMatchBreakdownWeightTotal(match) {
  return sumBy(match.breakdown, 'w')
}

export function getMatchBreakdownContributionTotal(match) {
  return sumBy(match.breakdown, 'ws').toFixed(MATCH_BREAKDOWN_DECIMALS)
}

export function getMatchBreakdownExcludedLabel({ match, t }) {
  return match.breakdown_excluded
    .map(item => t(getMatchCriterionLabelKey(item.key)))
    .join(RENTAL_PORTAL_FACT_SEPARATOR)
}

export function getMatchBreakdownExcludedWeight(match) {
  return match.breakdown_excluded
    .map(item => item.w)
    .join(RENTAL_PORTAL_FACT_SEPARATOR)
}
